import { FieldValues } from 'react-hook-form';

import { STATE_ABBREVIATION_TO_FULL_NAME } from '@willow/types-iso';

import { ControlledSimpleSelect, ControlledSimpleSelectProps } from './ControlledSimpleSelect';

const OPTIONS = Object.keys(STATE_ABBREVIATION_TO_FULL_NAME).map((stateAbbreviation) => ({
  value: stateAbbreviation,
  label: stateAbbreviation,
}));

type Props<T extends FieldValues> = Omit<ControlledSimpleSelectProps<T>, 'options'>;

export function ControlledStateSelect<T extends FieldValues>({
  control,
  fieldName,
  required,
  placeholder,
  ...props
}: Props<T>) {
  return (
    <ControlledSimpleSelect
      {...props}
      options={[
        {
          value: '',
          label: placeholder || 'Select State',
        },
        ...OPTIONS,
      ]}
      control={control}
      fieldName={fieldName}
      required={required}
    />
  );
}
